import { createFileRoute } from '@tanstack/react-router';
import { PerformanceDetailPage } from '@/pages/performance/PerformanceDetailPage';

export const Route = createFileRoute('/performance/$contentId')({
  component: PerformanceDetailRoute,
});

function PerformanceDetailRoute() {
  const { contentId } = Route.useParams();
  return <PerformanceDetailPage contentId={contentId} />;
}
